import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { goBack, lightImpactVibrate } from '../utils/appBridge'
import BackButton from '../components/ui-components/BackButton'
import MFHeaderSkeleton from '../components/skeletons/MFHeaderSkeleton'
import { RegularPlanAlertContent } from '../components/BottomSheetComponents/RegularPlanAlert'
import MetaDataProvider from '../state-management/providers/MetaDataProvider'
import { getBottomPadding, getTopPadding } from '../utils/sessionStorage'

export default function MutualFundDetailPage() {
  const [isin, setISIN] = useState('')
  const { isin: paramsISIN } = useParams<{ isin: string }>()

  const navigate = useNavigate()

  useEffect(() => {
    setISIN('')
    setTimeout(() => {
      setISIN(paramsISIN ?? '')
    }, 0)
  }, [paramsISIN])

  const [searchParams] = useSearchParams()

  const from = useMemo(() => {
    return searchParams?.get('from') ?? ''
  }, [searchParams])

  const handleBack = () => {
    lightImpactVibrate()
    if (from) goBack()
    else navigate(-1)
  }

  if (isin)
    return (
      <MetaDataProvider isin={isin} from={from} disableOnReady={true}>
        <div className='pt-6 pb-1 h-full w-full relative'>
          <div className='h-full pb-48 px-5 overflow-y-auto no-scrollbar'>
            <div className='text-[#232323] text-[22px] font-[400] pb-3'>Regular Fund Alert</div>
            <RegularPlanAlertContent isPage={true} />
          </div>
          <div className='sticky bottom-0 left-0 right-0'>
            <div
              style={{ paddingBottom: `${getBottomPadding() + 8}px` }}
              className='px-5 pt-1 bg-gradient-to-b from-[rgba(255,255,255,0)] via-[rgba(255,255,255,0.3)] to-[rgba(255,255,255,0.8)]'
            >
              <button
                onClick={() => {
                  lightImpactVibrate()
                  goBack()
                }}
                className='w-full py-2 px-4 bg-[#232323] text-white font-medium rounded-xl h-14 
        outline-none focus:outline-none'
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </MetaDataProvider>
    )

  return (
    <div className='flex flex-col gap-3 pl-[19px] pr-5 w-full h-screen'>
      <div style={{ paddingTop: `calc(${getTopPadding()}px + 18.5px)` }} className='flex pb-4'>
        <BackButton size={24} onClick={handleBack} />
      </div>
      <div>
        <MFHeaderSkeleton />
      </div>
    </div>
  )
}
